import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=20f46aa0&scoped=true"
import script from "./Generate.vue?vue&type=script&lang=ts"
export * from "./Generate.vue?vue&type=script&lang=ts"
import style0 from "./Generate.vue?vue&type=style&index=0&id=20f46aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f46aa0",
  null
  
)

export default component.exports